module.exports = __webpack_public_path__ + "static/img/icon-insurance-01.f87e1e9f.png";